"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12.04 8.04h-.09l-1.6 4.55h3.29z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m3.21 13-.98-2.81H9.78l-1 2.81h-1.9l4.13-11h1.97l4.13 11z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M11.01 6 6.88 17h1.9l1-2.81h4.44l.99 2.81h1.9L12.98 6zm-.66 6.59 1.6-4.55h.09l1.6 4.55z"
}, "3")], 'HdrAutoTwoTone');